import { appMetadata } from 'config';

export const getDefaultMataData = (appId: string | null) => {
  return appId
    ? appId === 'OFFFCOURSE'
      ? appMetadata.offfcourse
      : appMetadata.event
    : null;
};
